import styled from "styled-components";

export const DemoWrapper = styled.div`

.list {
    width: 100px;
}

`